/**
 * AboutYouFields.js
 *
 * Renders the input fields for the "About You" onboarding step.
 */
import React from 'react';
import PropTypes from 'prop-types';
import FormField from '@/forms/_common/FormField';
import StringField from '@/forms/_fields_v2/StringField';

AboutYouFields.propTypes = {
  data: PropTypes.object.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
};

/**
 * Component for the "About You" form fields.
 *
 * @param {object} props - Component props.
 * @returns {JSX.Element} The rendered form fields.
 */
export default function AboutYouFields(props) {
  const { data, errors, onChange } = props;
  return (
    <div className="min-w-80 max-w-[500px] flex flex-col mb-12">
      <div className="w-full mb-6">
        <FormField name="firstName" data={data} errors={errors} onChange={onChange}>
          {(field) => (
            <StringField
              label="First name"
              required={true}
              value={field.value}
              error={field.error}
              onChange={field.onChange}
            />
          )}
        </FormField>
      </div>
      <div className="w-full mb-6">
        <FormField name="lastName" data={data} errors={errors} onChange={onChange}>
          {(field) => (
            <StringField
              label="Last name"
              required={true}
              value={field.value}
              error={field.error}
              onChange={field.onChange}
            />
          )}
        </FormField>
      </div>
      <div className="w-full">
        <FormField name="phoneNumber" data={data} errors={errors} onChange={onChange}>
          {(field) => (
            <StringField
              label="Phone"
              placeholder="(000) 000-0000"
              description="Your phone number will not be displayed on your public profile. We'll only use it if we need to contact you to support or notify you of a cancellation or time-sensitive issue related to an activity you're involved in."
              value={field.value}
              error={field.error}
              onChange={field.onChange}
            />
          )}
        </FormField>
      </div>
    </div>
  );
}
